import React, { useState, useEffect } from "react";
// styles
import "../pages.css";
// utils
import XGridDemo from "../../components/utils/grid/Xgrid";
import TransitionModal from "../../components/utils/modals/Modals";
import Buttons from '../../components/utils/buttonsContainer/Buttons';
// consts
import { cargos as titles } from "../../consts/titulos-de-tablas";
import { modalsInfoCargos as infoModal } from "../../consts/Modals-info";
//Assets
import CircularIndeterminate from '../../components/utils/spinner/Spinner';
//Services 
import { retrieveData } from '../../services/Local-services';
import { cargosGet } from '../../services/hooli-services/Cargos/CargosGet';
// recoil
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import { userCredentials, rowSelected, formData } from '../../recoilState/GlobalState';

export default function Cargos() {
    const [cargos, setCargos] = useState([]);
    const [rows, setRows] = useState([]);
    const [action, setAction] = useState({});
    const [cargando, setCargando] = useState(true);

    const [{ status }, setRow] = useRecoilState(rowSelected);
    const setFormInfo = useSetRecoilState(formData);
    const credentials = useRecoilValue(userCredentials);

    const updateList = async () => {
        setCargando(true);
        await retrieveData(credentials, setRows, cargosGet, setCargos);
        setCargando(false);
    };

    useEffect(() => {
        if (Object.keys(credentials).length > 0) updateList()
    }, [credentials]);

    useEffect(() => {
        cargos.map((item) => {
            const {
                cargoId,
                cargoNombre,
                cargoCod,
                cargoVersion,
            } = item

            const cargo = {
                id: cargoId,
                version: cargoVersion,
                [titles[0]]: cargoNombre,
                [titles[1]]: cargoCod
            }

            setRows(rows => [...rows, cargo])
            return item
        });
    }, [cargos]);

    useEffect(() => setRow({ status: false }), [])

    const handleClick = ({ action, procede }) => {
        setFormInfo(infoModal[action]);
        setAction({ action, procede });
    };

    return (
        <main className="container">
            <TransitionModal
                titles={titles}
                procede={action.procede}
                updateList={updateList}
            />
            <Buttons texto="cargo" handleClick={handleClick} updateList={updateList}/>
            <div className="row-grid">
                {cargando ? <CircularIndeterminate /> : <XGridDemo rows={rows} titles={titles} />}
            </div>
        </main>
    )
};